import { render } from "./Header.vue?vue&type=template&id=31af14e4"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=31af14e4&lang=css"
script.render = render

export default script